var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echartsBox"},[_c('div',{ref:"ecahrts",staticClass:"ecahrts",on:{"mouseover":function($event){_vm.autoTimePaused = true},"mouseout":function($event){_vm.autoTimePaused = false}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }